export default __webpack_public_path__ + "static/media/project-2.1.5732a8e3.png";